import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { wrapDisplayName } from 'recompose';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import {
  mapState,
  getResult,
  createCancelToken,
} from '@deerplusofficial/pos-helper';
import { refactorItem } from './withQueryProduct';
import actions from '../../actions';

const combine = fp.compose(
  fp.trim,
  fp.join(' ')
);

const modifyProductItems = ({ name, id, product_items }) =>
  _.map(product_items, item =>
    _.omit(
      {
        name,
        productId: id,
        ...refactorItem(item),
      },
      'discounts'
    )
  );

const getProductItems = fp.compose(
  fp.flatMap(modifyProductItems),
  fp.flatMap(({ products }) => products)
);

const modifyProducts = fp.map(
  ({ name, quantity, barcodes, skus, ...productProps }) => {
    return {
      name,
      storage: quantity,
      barcodes: combine(barcodes),
      skus: combine(skus),
      ..._.omit(productProps, ['product_items']),
    };
  }
);

const modifyCategories = fp.map(({ id, products, name, ...categoryProps }) => ({
  id: id || 'ungrouped',
  products: modifyProducts(products),
  name: _.size(name) ? name : '未分類',
  ...categoryProps,
}));

const modifyDiscounts = fp.map(({ value, criteria, ...discountProps }) => ({
  criteria,
  ...discountProps,
  formattedValue: criteria === 0 ? String(value) : `${value}%`,
}));

const {
  fetch: { toggle: toggleFetching },
  add,
} = actions.products;

export default () => Component =>
  fp.compose(
    withRouter(),
    withClient(),
    connect(
      mapState(['products']),
      { toggleFetching, add }
    )
  )(
    class extends React.PureComponent {
      static displayName = wrapDisplayName(Component, 'WithQueryProducts');

      componentWillUnmount() {
        !_.isUndefined(this.cancelFetch) && this.cancelFetch();
      }

      onFetch = async () => {
        const {
          client: { onError, POSApi },
          products: { fetching },
          channelId,
          add,
          toggleFetching,
        } = this.props;

        if (fetching) return;

        try {
          toggleFetching();

          const { categories, discounts } = getResult(
            await POSApi.get(`/pos/channels/${channelId}/products`, {
              cancelToken: createCancelToken(this.cancelFetch),
            })
          );

          const { payment_methods } = getResult(
            await POSApi.get(
              `/pos/payment_methods`,
              {
                params: { channel_id: channelId },
              },
              { cancelToken: createCancelToken(this.cancelFetch) }
            )
          );

          add({
            lineups: modifyCategories(categories),
            items: getProductItems(categories),
            discountOptions: modifyDiscounts(discounts),
            paymentMethods: payment_methods,
          });
        } catch (e) {
          onError(e);
        } finally {
          toggleFetching();
        }
      };

      render() {
        return <Component {...this.props} fetchProducts={this.onFetch} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryProducts.js